import { IncludedKeywordCategoryRequestCode } from '@doda/api-client/aspida/@types';

/**
 * キーワードクエリを生成する関数
 *
 * @param {string[]} keyword - キーワードの配列
 * @param {IncludedKeywordCategoryRequestCode | undefined} category - キーワードカテゴリのコード
 * @param {boolean} isInclude - キーワードを含めるかどうかのフラグです。
 * @returns {{ keyword: string | undefined; category: string | undefined }} キーワードとカテゴリを含むクエリオブジェク
 */
export const createKeywordQuery = (
  keyword: string[],
  category: IncludedKeywordCategoryRequestCode | undefined,
  isInclude: boolean
) => {
  const queryKey = {
    keyword: isInclude ? 'feak' : 'feani',
    category: isInclude ? 'feakwc' : 'feaniwc',
  };

  if (keyword.length) {
    return {
      keyword: `${queryKey.keyword}=${encodeURIComponent(
        keyword.filter((item) => item !== '').join(',')
      )}`,
      category: `${queryKey.category}=${category === '5' ? '9' : category}`,
    };
  }

  return {
    keyword: undefined,
    category: undefined,
  };
};
